module.exports = __webpack_public_path__ + "img/system12-details.c26a7652.png";